import module from 'facturacion/facturas/module.js'

module.config(($stateProvider) => {
  $stateProvider.state('facturacion.facturar33.ingreso.masivo', {
    url: '',
    data: {title: 'Facturas masivas'},
    params: {data: {}, catalogos: {}},
    views: {
      '@facturacion.facturar33.ingreso': {
        resolve: {
          data: ($stateParams) => $stateParams.data,
          catalogos: ($stateParams) => $stateParams.catalogos,
        },
        controller: ($scope, data, catalogos) => {
          $scope.data = data
          $scope.catalogos = catalogos
        },
        template: '<facturacion-facturar-ingreso-masivo data="data" catalogos="catalogos"></facturacion-facturar-ingreso-masivo>',
      },
    },
  })
})



// WEBPACK FOOTER //
// ./src/facturacion/facturas/routes/ingreso/masivo.js